import { render, staticRenderFns } from "./materialRequisitionDetail.vue?vue&type=template&id=3323e9ce&scoped=true&"
import script from "./materialRequisitionDetail.vue?vue&type=script&lang=js&"
export * from "./materialRequisitionDetail.vue?vue&type=script&lang=js&"
import style0 from "./materialRequisitionDetail.vue?vue&type=style&index=0&id=3323e9ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3323e9ce",
  null
  
)

export default component.exports